import store from '../../store'
import moment from 'moment'
import 'moment/locale/zh-cn'
// import { reportPdf } from '../../service'
const state = store.state
// const req_url = (state.env == 'development' ? '/api' : 'http://data-api.vcbeat.cn')
const req_url = state.req_url
const img_req_url = state.img_req_url
const static_img = state.static_img_url

const filter = {
  deal(p, dir, w = 'name', a = '--') { // 基本过滤,w表示返回字段,dir表示用哪一个字典
    if (state[dir] == '') {
      return a
    }
    let i = state[dir].findIndex((item) => item.id == p)
    if (p + '' &&  i!= -1) {
      return state[dir][i][w]
    } else {
      return a
    }
  },
  dealName(p, dir, f = 'id', w = 'name', a = '--') { // 基本过滤,w表示返回字段,dir表示用数组
    if(dir && dir.length > 0) {
      let index = dir.findIndex((b) => b[f] == p)
      if(index > -1) {
        return dir[index][w]
      }else {
        return a
      }
    }else {
      return a
    }
  },
  dealArrayName(arr, dir, f = 'id', w = 'name', a = '--') {
    if(arr.length && dir.length) {
      let str = arr.map((a) => {
        let index = dir.findIndex((b) => b[f] == a)
        if(index > -1) {
          return dir[index][w]
        }else {
          return a
        }
      })
      return str.join('、')
    } else {
      return a
    }
  },
  dealNeed(p, dir, w = 'name', a = '--') { // 基本过滤,w表示返回字段,dir表示用哪一个字典(按需加载时使用)
    let i = dir.findIndex((item) => item.id == p)
    if (p + '' &&  i!= -1) {
      return dir[i][w]
    } else {
      return a
    }
  },
  addressDeal(data_id, len = '1', arr, a = '--') { // 地址过滤  len 1显示 中国，2显示为 中国-重庆
    let address_arr = []
    if(arr && arr.length) {
      address_arr = arr
    } else {
      address_arr = state.address || []
    }
    if(data_id && data_id != '0' && address_arr.length) {
      let index = address_arr.findIndex((a) => a.id == data_id)
      let item = address_arr[index]
      if(item.gpid == null && item.pid == null){
        return item.name
      }
      if(item.gpid == null && item.pid != null){
        let idx = address_arr.findIndex((a) => a.id == item.pid)
        if(len == '1'){
          return address_arr[idx].name
        }else if(len == '2' || len == '3'){
          return address_arr[idx].name + '-' + item.name
        }
      }
      if(item.gpid != null && item.pid != null){
        let idx = address_arr.findIndex((a) => a.id == item.id)
        let idx1 = address_arr.findIndex((a) => a.id == item.pid)
        let idx2 = address_arr.findIndex((a) => a.id == item.gpid)

        if(len == '1'){
          return address_arr[idx2].name
        }else if(len == '2'){
          return address_arr[idx2].name + '-' + address_arr[idx1].name
        }else if(len == '3'){
          return address_arr[idx2].name + '-' + address_arr[idx1].name + '-' + address_arr[idx].name
        }
      }
    } else{
      return a
    }
  },
  dealString(p, dir, w = 'name') { // 基本过滤字符串,w表示返回字段,dir表示用哪一个字典
    if (state[dir] == '') {
      return '--'
    }
    if (p) {
      if (typeof(p) == 'object' && p.length == 0) {
        return '空'
      }
      let temp
      if (typeof(p) == 'object') {
        temp = p
      } else {
        temp = p.split(',')
      }
      // let temp = p.split(',')

      let arr = []
      for(let item of temp) {
        let index = state[dir].findIndex((item1) => item1.id+'' == item)
        if (index > -1) {
          arr.push(state[dir][index][w])
        }
      }
      return arr.join('、')
    } else {
      return '--'
    }
  },
  array2string(arr) {
    if(arr.length) {
      return arr.join('、')
    } else {
      return '--'
    }
  },
  len20(str) {
    return str.length > 20 ? str.substring(0, 20) + '...' : str
  },
  isno(p, is = '是', no = '否') { // 是否过滤, is为真, no为假
    if (p == null || p == undefined) {
      return '--'
    } else {
      return parseInt(p) ? is : no
    }
  },
  empty(v, x='--') { // 剔除空值的情况, x为想要显示的控制的参数
    return v ? v : x
  },
  page(v) { // 识别网站http
    if (v) {
      // var match = /^((ht|f)tps?):\/\/[\w\-]+(\.[\w\-]+)+([\w\-\.,@?^=%&:\/~\+#]*[\w\-\@?^=%&\/~\+#])?$/
      var match = /^(http|https|ftp):\/\//
      if (match.test(v)) {
        return v
      } else {
        return 'http://' + v
      }
    } else {
      return '--'
    }
  },
  timeTrans(p, a = '--') { // 时间过滤(精确到日)
    if(p) {
      if (p.indexOf('T') != -1) {
        return p.split('T')[0]
      }
      if (p.indexOf(' ') != -1) {
        return p.split(' ')[0]
      }
    } else {
      return a
    }
  },
  time_moment(t, f = 'YYYY-MM-DD') { // 用moment处理时间
    if(t) {
      return moment(t).format(f)
    }else {
      return '--'
    }
  },
  time_moment_second(t, f="YYYY-MM-DD HH:mm") {
    let time = moment(t)
    if(time) {
      return moment(time).format(f)
    }else {
      return '--'
    }
  },
  time_standard(t) { // 用moment处理时间
    let time = moment(t)
    let now = moment()
    let du = moment.duration(now - time)._milliseconds
    if(du < 259200000) { // 三天
      return moment(t).fromNow()
    } else {
      return moment(t).format('YYYY-MM-DD')
    }
  },
  time_standard_day(t) { // 用moment处理时间 保留日月
    let time = moment(t)
    let now = moment()
    let du = moment.duration(now - time)._milliseconds
    if(du < 86400000) { // 一天
      return moment(t).fromNow()
    } else {
      return moment(t).format('MM-DD')
    }
  },
  time_deal(t) { //js将秒转换为时分秒
    let secondTime = parseInt(t)//将传入的秒的值转化为Number
    let min = 0// 初始化分
    let h =0// 初始化小时
    let result=''
    if(secondTime>60){//如果秒数大于60，将秒数转换成整数
      min=parseInt(secondTime/60)//获取分钟，除以60取整数，得到整数分钟
      secondTime=parseInt(secondTime%60)//获取秒数，秒数取佘，得到整数秒数
      if(min>60){//如果分钟大于60，将分钟转换成小时
        h=parseInt(min/60)//获取小时，获取分钟除以60，得到整数小时
        min=parseInt(min%60) //获取小时后取佘的分，获取分钟除以60取佘的分
        result=`${h.toString().padStart(2,'0')}:${min.toString().padStart(2,'0')}:${secondTime.toString().padStart(2,'0')}`
      }else{
        result=`${min.toString().padStart(2,'0')}:${secondTime.toString().padStart(2,'0')}`
      }
    }else{
      result=`${min.toString().padStart(2,'0')}:${secondTime.toString().padStart(2,'0')}`
    }
    return result
  },
  pc(p, c, a = '--') { // 省市过滤
    if (p) {
      if (c) {
        return p + ' · ' + c
      } else {
        return p
      }
    } else {
      return a
    }
  },
  se(start, end) { // 时间区间过滤
    if (start) {
      if (end) {
        return moment(start).format('YYYY-MM-DD') + ' ~ ' + moment(end).format('YYYY-MM-DD')
      } else {
        return moment(start).format('YYYY-MM-DD') + '~至今'
      }
    } else {
      return '--'
    }
  },
  logo_show(path, route = '', default_img = '') { // 图片
    if (path && path != '--') {
      return img_req_url + path + route
    } else {
      // return require('../pic/default-logo.png')
      return default_img
    }
  },
  img_path(path) { // 图片
    if (path && path != '--') {
      return static_img + path
    } else {
      // return require('../pic/default-logo.png')
      return ''
    }
  },
  tel(tel) { // 电话
    if(tel) {
      let r = /(\d{3})(\d{4})(\d{4})/
      return tel.replace(r, "$1****$3")
    } else {
      return '暂无电话'
    }
  },
  amountPrecise(a, unit_id, p = 1, dir) { // 融资额是否精确,精确（包含币种符号和万字）,不精确数百亿
    if (a == null || a == 0) {
      return '未透露'
    }
    // 没有币种默认人民币
    if (!unit_id) {
      unit_id = 1
    }
    let item = {}
    if (dir && dir.length > 0) {
      item = dir.find((item) => item.id == unit_id) || {}
    } else {
      item = state.unit.find((item) => item.id == unit_id) || {}
    }
    const symbols = item.symbols || ''
    const unit_name = item.name || ''
    const tenThousand = 10000

    if (p == 0) {
      let value = a / tenThousand
      let amountArr = ['数万', '数十万', '数百万', '数千万', '数亿', '数十亿', '数百亿', '数千亿']
      let idx = 0
      while (value / 10 >= 1) {
        value /= 10
        idx++
      }
      return `${amountArr[idx]}${unit_name}` || '未透露'
    } else {
      let value
      if (a >= 100000000) {
        value = a / 100000000 + '亿'
      } else if (a >= 10000) {
        value = a / 10000 + '万'
      } else {
        value = a
      }
      const str = {
        1: `${symbols}${value}`,
        2: `近${value}${unit_name}`,
        3: `超${value}${unit_name}`,
      }
      return str[p] || '未透露'
    }
  },
  amountPrecise2(a, unit_id, dir) { //股价信息金额
    if(a==null||a==0){
      return '未透露';
    }
    // 没有币种默认人民币
    if (!unit_id) {
      unit_id = 1
    }
    let symbols, unit_name
    if(dir && dir.length > 0) {
      symbols = dir[dir.findIndex((item) => item.id == unit_id)]['symbols']
      unit_name = dir[dir.findIndex((item) => item.id == unit_id)]['name']
    } else {
      symbols = state.unit[state.unit.findIndex((item) => item.id == unit_id)]['symbols']
      unit_name = state.unit[state.unit.findIndex((item) => item.id == unit_id)]['name']
    }
    let num = 0
    if(a/100000000>=1){
      num = a/100000000
      return symbols + num.toFixed(2) + '亿'
    }else{
      num = a/10000
      return symbols + num.toFixed(2) +'万'
    }
  },
  amount(a, p) {  //金额  单位万
    if(a==null||a==0){
      return '未透露';
    }
    if(p == 1){
      return a/10000;
    } else if (p == 0){
      let t = a/10000;
      let unit=['数万','数十万','数百万','数千万','数亿','数十亿','数百亿','数千亿'];
      let idx=0;
      while(t/10>=1){
        t = t/10;
        idx++;
      }
      return unit[idx];
    } else{
      let t = a/10000;
      let unit=['近万','近十万','近百万','近千万','近亿','近十亿','近百亿','近千亿'];
      let idx=0;
      while(t/10>=1){
        t = t/10;
        idx++;
      }
      return unit[idx];
    }
  },
  amountJustPrecise(a) {
    if(a==null||a==0){
      return '--';
    }
    if(a/100000000>=1){
      return  a/100000000 + '亿'
    }else if(a/10000>=1){
      return  a/10000+'万';
    }else {
      return a
    }
  },
  amountJustPrecise2(a) {
    if(a==null||a==0){
      return '--';
    }
    if(a/100000000>=1){
      return  (a/100000000).toFixed(2) + '亿'
    }else if(a/10000>=1){
      return  (a/10000).toFixed(2)+'万';
    }else {
      return +a
    }
  },
  amountJustRMBPrecise2(a) {
    if(a==null||a==0){
      return '--';
    }
    if(a/100000000>=1){
      return  '￥'+(a/100000000).toFixed(2) + '亿'
    }else if(a/10000>=1){
      return  '￥'+(a/10000).toFixed(2)+'万';
    }else {
      return +a
    }
  },
  amountRateChange(a, before_unit_id = 1, after_unit_id) { //金额,当前币种id,目标币种id
    if(a == null || a == 0){
      return '未透露'
    } else {
      let before_index = state.unit.findIndex((item) => item.id == before_unit_id)
      let after_index = state.unit.findIndex((item) => item.id == after_unit_id)

      let before_rate = state.unit[before_index]['rate']
      let after_rate = state.unit[after_index]['rate']

      let symbols = state.unit[after_index]['symbols']

      let after_amount = (a*before_rate)/after_rate

      if(after_amount/100000000>=1){
        return symbols + Math.round(after_amount/100000000*100)/100 + '亿'
      }else{
        return symbols + Math.round(after_amount/10000)+'万';
      }
    }
  },
  amountChangeAveRate(a, before_unit_id = 1, after_unit_id, y1, y2, dw = '亿') {  //金额,当前币种id,目标币种id,年份1，年份2, 单位
    if(a == null || a == 0){
      return 0
    } else {
      let before_index1 = state.currency_year_rate.findIndex((item) => item.currency_id == before_unit_id && item.year == y1)
      let before_index2 = state.currency_year_rate.findIndex((item) => item.currency_id == before_unit_id && item.year == y2)

      let after_index1 = state.currency_year_rate.findIndex((item) => item.currency_id == after_unit_id && item.year == y1)
      let after_index2 = state.currency_year_rate.findIndex((item) => item.currency_id == after_unit_id && item.year == y2)

      let before_rate_arr = state.currency_year_rate.slice(before_index1, before_index2+1)
      let after_rate_arr = state.currency_year_rate.slice(after_index1, after_index2+1)

      let before_rate ,before_rate_t = 0
      before_rate_arr.map((a) => before_rate_t += Number(a.rate))
      before_rate = before_rate_t/before_rate_arr.length

      let after_rate ,after_rate_t = 0
      after_rate_arr.map((a) => after_rate_t += Number(a.rate))
      after_rate = after_rate_t/after_rate_arr.length

      if(dw == '亿'){
        return Math.round((a*before_rate)/after_rate/100000000*100)/100
      }else if(dw == '万'){
        return Math.round((a*before_rate)/after_rate/10000*100)/100
      }

    }
  },
  amountFilter(a, dw = '亿') {
    if(dw == '亿'){
      return Math.round(a/100000000*100)/100
    }else if(dw == '万'){
      return Math.round(a/10000*100)/100
    }
  },
  amountFilter2(a, dw = '千万') {
    if(dw == '千万'){
      return Math.round(a/10000000*100)/100
    }else if(dw == '万'){
      return Math.round(a/10000*100)/100
    }
  },
  attentioned(id, id_arr) { // 是否已关注公司或机构
    id = id + ''
    id_arr = id_arr.map(item => item + '')
    if (id_arr.indexOf(id) != -1) {
      return true
    } else {
      return false
    }
  },
  firstname(name) {
    if (name) {
      return name.substring(0,1)
    } else {
      return ''
    }
  },
  numberFormatter(num) { //数字格式化
    if(num >= 0 && num < 10) {
      return '0' + num
    }else {
      return num
    }
  },
  changeBase64(txt) {
    return window.btoa(txt)
  },

  hosLevel(l1, l2){
    if(l1 && l2){
      let l_id = l1 + '' + l2
      let index = state.hos_level.findIndex(item => l_id == item.id)
      return state.hos_level[index].name
    } else {
      return '--'
    }
  },
  keyWordHighLight(contents, key_word){
    let values = contents.split(key_word);
    return values.join('<i class="high-light">' + key_word + '</i>')
  },
  tct_time_list(y, t) {
    if (t == 0 || t == 2) {
      return y
    } else if (t == 1) {
      let y1 = y.split('Q')[0],
          y2 = y.split('Q')[1]
      if (y2 == 1) {
        return y1 + '.Q' + y2
      } else {
        return 'Q' + y2
      }
    }
    // if (t == 0) {
    //   return y
    // } else if (t == 1) {
    //   let y1 = y.split('Q')[0],
    //       y2 = y.split('Q')[1]
    //   if (y2 == 1) {
    //     return y1 + '.Q' + y2
    //   } else {
    //     return 'Q' + y2
    //   }
    // } else if (t == 2) {
    //   let y1 = y.split('.')[0],
    //       y2 = y.split('.')[1]
    //   if (y2 == 1) {
    //     return y1 + '.0' + y2
    //   } else {
    //     return y2 < 10 ? '0'+y2 : y2
    //   }
    // }
  },
  getPgidName(id, dir) {
    let index = dir.findIndex(a => a.id == id)
    if (index > -1) {
      if (dir[index].pid != null && dir[index].gpid != null) {
        let index_p = dir.findIndex(a => a.id == dir[index].gpid)
        return dir[index_p].name
      }
      if (dir[index].pid != null && dir[index].gpid == null) {
        let index_p = dir.findIndex(a => a.id == dir[index].pid)
        return dir[index_p].name
      }
    }
  },
  getPidName(id, dir) {
    let index = dir.findIndex(a => a.id == id)
    if (index > -1) {
      if (dir[index].pid != null && dir[index].gpid != null) {
        let index_p = dir.findIndex(a => a.id == dir[index].pid)
        return dir[index_p].name
      }
      if (dir[index].pid != null && dir[index].gpid == null) {
        let index_p = dir.findIndex(a => a.id == dir[index].id)
        return dir[index_p].name
      }
    }
  },
  // mobile
  timeToMonth(p) { // 只取月份
    let temp = p.split('-')
    if (parseInt(temp[1])> 9) {
      return temp[1]
    } else {
      return temp[1].split('')[1]
    }
  },
  timeToYear(p) { // 只取年份
    let temp = p.split('-')
    return temp[0]
  },
  dealTitle(p) {
    if (!p) {
      return ''
    }
    let rep = new RegExp('&amp;','g')
    return p.replace(rep, '&')
  },

  numberMax(num) {
    if(num < 1000) {
      return num
    }else {
      return '999+'
    }
  },

  format_number(n, e) {
    if (n) {
      var b = parseInt(n).toString();
      var len = b.length;
      if (len <= 3) { return b; }
      var r = len % 3;
      return r > 0 ? b.slice(0, r) + "," + b.slice(r, len).match(/\d{3}/g).join(",") : b.slice(r, len).match(/\d{3}/g).join(",");
    } else {
      return e ? e : 0
    }
  },

  floatNumber(f) {
    return Math.round((f - 0) * 100) / 100
  },

  activityAddress(province, city, address) {
    let p = province ? province + ' ' : ''
    let c = city ? city + ' ' : ''
    return p + c + address
  }

}

export default filter
